import { useCallback } from 'react';

import { useAppDispatch } from '@redux/hooks';

import { EThemesEnum } from '@enum';

import { themeSlice } from '@redux/reducers/theme';

export const useThemeSwitcher = () => {
  const dispatch = useAppDispatch();

  const { setTheme } = themeSlice.actions;

  return useCallback(
    (theme: EThemesEnum) => {
      dispatch(setTheme(theme));
    },
    [dispatch],
  );
};
